import script from "./MTSSReferralTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MTSSReferralTable.vue?vue&type=script&setup=true&lang=ts"

import "./MTSSReferralTable.vue?vue&type=style&index=0&id=1dd94342&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd94342"]])

export default __exports__